import cx from 'classnames';

export interface FormMessageProps {
  children?: React.ReactNode;
  message?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  variant?: 'light' | 'dark';
  align?: 'center' | 'left';
  className?: string;
}

export const FormMessage: React.FC<FormMessageProps> = (props) => {
  const { children, message, type = 'error', variant = 'light', align = 'center' } = props;

  if (!message && !children) return null;

  return (
    <div
      className={cx(
        'FormMessage',
        `FormMessage--${type}`,
        `FormMessage--${variant}`,
        'text-body-medium',
        `text--${align}`,
        props.className
      )}
    >
      <span>{children || message}</span>
    </div>
  );
};
